module.exports = __webpack_public_path__ + "img/mssql.6e0f0ecc.svg";